import { render } from "./IconTopUp.vue?vue&type=template&id=b802da3a"
import script from "./IconTopUp.vue?vue&type=script&lang=js"
export * from "./IconTopUp.vue?vue&type=script&lang=js"

import "./IconTopUp.vue?vue&type=style&index=0&id=b802da3a&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__